module.exports = __webpack_public_path__ + "img/home_people.53762a6d.png";